<template>
  <div id="qvv_reff">
    <h1>Reproduktionszahl für Österreich und die Bundesländer</h1>
    <p>
      Geschätzte effektive Reproduktionszahl bezogen auf die vorangegangenen 13
      Epidemietage inklusive Schwankungsbreite.
    </p>
    <div class="controls" v-if="false">
      <button
        v-for="k in POSSIBLE_VALUES_ORDER"
        :key="k"
        @click="value = k"
        v-html="POSSIBLE_VALUES[k].title"
        :class="{ active: value == k }"
        :disabled="value == k ? 'disabled' : null"
      ></button>
      <button @click="toggle_scatter_x()" v-if="false">x axis toggle</button>
    </div>
    <div class="graph">
      <div
        v-for="x in erste_n_bezirke"
        :key="x.Bundesland"
        :class="`bezirk ${x.Bundesland}`"
      >
        <h4 v-if="x.Bundesland == 'Österreich'">
          Eine positiv getestete Person steckte in
          <span :style="{ borderBottom: `3px solid #8e8e8e` }">
            Österreich
          </span>
          <b :style="{ color: `#8e8e8e` }">
            {{ POSSIBLE_VALUES[value].formatter(x[value]) }}
          </b>
          weitere Personen an
        </h4>
        <h4 v-else>
          <span
            :style="{
              borderBottom: `3px solid ${
                x.Bundesland == 'Österreich' ? '#8e8e8e' : '#CA5775'
              }`
            }"
          >
            {{ x.Bundesland
            }}{{ POSSIBLE_VALUES[value].formatter(x[value]) != "" ? ":" : "" }}
          </span>
          {{ POSSIBLE_VALUES[value].formatter(x[value]) }}
        </h4>
        <div class="scatter_wrapper">
          <BezirksScatterplotNeuReff
            :bezirk="bezirkeWerte[x.Bundesland]"
            :color="x.Bundesland == 'Österreich' ? '#8e8e8e' : '#CA5775'"
            :alle="
              x.Bundesland == 'Österreich' ? [] : bezirkeWerte['Österreich']
            "
            :value="value"
            :formatter="POSSIBLE_VALUES[value].formatter"
            :other_values="POSSIBLE_VALUES_ORDER.filter(d => d != value)"
            :other_values_instructions="POSSIBLE_VALUES"
            :xaxis="scatter_x"
          >
          </BezirksScatterplotNeuReff>
        </div>
      </div>
    </div>
    <p class="detail"></p>
    <footer>
      <p class="source">
        Quelle: cc-by <a href="https://www.ages.at/en/wissen-aktuell/publikationen/epidemiologische-parameter-des-covid19-ausbruchs-oesterreich-20202021/" target="_blank">AGES, TU Graz</a>
      </p>
    </footer>
  </div>
</template>

<script>
import BezirksScatterplotNeuReff from "./components/BezirksScatterplotNeuReff.vue";
import Vue from "vue";
import * as fetch from "d3-fetch";

export default {
  name: "Reff",
  components: {
    BezirksScatterplotNeuReff
  },
  data: () => {
    const POSSIBLE_VALUES = {
      "Obere Grenze": {
        parser: x => parseFloat(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2f")(x)),
        title: "Obere Grenze"
      },
      "Untere Grenze": {
        parser: x => parseFloat(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2f")(x)),
        title: "Untere Grenze"
      },
      Reproduktionszahl: {
        parser: x => parseFloat(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2f")(x)),
        title: "Reproduktionszahl"
      }
    };
    return {
      mobile: false,
      cutoff: true,
      value: "Reproduktionszahl",
      POSSIBLE_VALUES: POSSIBLE_VALUES,
      POSSIBLE_VALUES_ORDER: [
        "Reproduktionszahl",
        "Untere Grenze",
        "Obere Grenze"
      ],
      bezirksdaten_timeline: [],
      selected_element: null,
      cutoff_length: 10,
      scatter_x: "day"
    };
  },
  mounted() {
    window.addEventListener("resize", this.update_mobile);
    this.update_mobile();
    this.$nextTick(this.fetch_data);
  },
  methods: {
    update_mobile() {
      this.mobile = window.innerWidth < 700;
    },
    arrowkeys(key) {
      if (key == "down") {
        this.highlight_index += 1;
      }
      if (key == "up") {
        this.highlight_index -= 1;
      }
      this.highlight_index = Math.max(
        Math.min(this.highlight_index, this.results.length - 1),
        -1
      );
      if (key == "enter") {
        this.select(this.results[this.highlight_index]);
        this.$refs.vue_search.$refs.search_field.blur();
      }
    },
    select(r) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: window.pymChild ? "event" : "qvv_data_event",
          action: "2020-corona-bezirke",
          label: "search"
        });
      }
      this.selected_element = r;
      this.results = [];
      this.$refs["vue_search"].clear();
    },
    toggle_scatter_x() {
      this.scatter_x = this.scatter_x == "day" ? "bf" : "day";
    },
    fetch_data() {
      fetch.csv(`${process.env.BASE_URL}r_eff.csv`).then((data) => { //eslint-disable-line
        this.bezirksdaten_timeline = data;
      });
    }
  },
  computed: {
    max() {
      var max = 0;
      this.bezirksdaten_timeline.map(d => {
        max = Math.max(max, d[this.value]);
      });
      return max;
    },
    bezirke() {
      return [...new Set(this.bezirksdaten_timeline.map(d => d.Bundesland))];
    },
    bezcodename() {
      return this.bezirke.map(bezcode => ({
        bezcode: bezcode,
        name: this.bezirkeWerte[bezcode][0].Bundesland
      }));
    },
    datumswerte() {
      return [...new Set(this.bezirksdaten_timeline.map(d => d.day))];
    },
    stand() {
      return ""; //this.bezirksdaten_timeline[0].stand;
    },
    bezirkeWerte() {
      return Object.fromEntries(
        this.bezirke.map(bezirk => {
          const tmp = this.bezirksdaten_timeline.filter(
            d => d.Bundesland == bezirk
          );
          tmp.sort((a, b) => a.day.localeCompare(b.day));
          return [bezirk, tmp];
        })
      );
    },
    erste_n_bezirke() {
      const tmp = Object.entries(this.bezirkeWerte).map(d => d[1].slice(-1)[0]);
      tmp.sort((a, b) => {
        if (a.Bundesland == "Österreich") {
          return -1;
        }
        if (b.Bundesland == "Österreich") {
          return 1;
        }
        var br = +b.Reproduktionszahl;
        var ar = +a.Reproduktionszahl;
        if (isNaN(br)) {
          return -1;
        }
        if (isNaN(ar)) {
          return 1;
        }
        return +br - +ar;
      });
      return tmp.slice(0, this.cutoff ? this.cutoff_length : tmp.length);
    },
    selected_element_value() {
      return this.POSSIBLE_VALUES[this.value].formatter(
        this.bezirkeWerte[this.selected_element.bezcode].slice(-1)[0][
          this.value
        ]
      );
    }
  }
};
</script>

<style scoped>
#qvv_reff {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 21px;
}

h1 {
  font-family: Roboto, sans-serif;
  font-size: 22px;
  line-height: 29px;
  margin-bottom: 12px;
  margin-top: 0;
  font-weight: bold;
}

div.graph {
  margin-top: 24px;
  margin-bottom: 24px;
}

footer {
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
}

p.detail {
  font-size: 14px;
  line-height: 21px;
  margin: 0;
}

footer p.source {
  color: #888;
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  flex: 1;
  padding-top: 1px;
  -webkit-text-size-adjust: 100%;
}
p.source strong {
  font-weight: normal;
  text-transform: uppercase;
}

p {
  line-height: 21px;
  margin: 0px;
}

@media (max-width: 700px) {
  table {
    font-size: 12px;
    line-height: 16px;
  }
  tr th,
  tr td {
    padding: 4px 5px 0px;
  }

  p.detail {
    font-size: 11px;
    line-height: 14px;
  }
}

.graph {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.bezirk {
  display: flex;
  flex-direction: column;
  width: 200px;
  padding: 5px;
  justify-content: flex-end;
}
.bezirk .scatter_wrapper {
  width: 190px;
  height: 190px;
}

@media (max-width: 450px) {
  .bezirk {
    width: 50%;
    padding: 0;
  }
  .bezirk .scatter_wrapper {
    width: 100%;
    height: 50vw;
  }
}

.search {
  position: relative;
}

.search >>> input {
  width: 100%;
  border: 1px solid grey;
}

.search .results {
  width: 100%;
  max-width: 450px;
  position: absolute;
  border: 1px solid #333;
  border-bottom: none;
  box-sizing: border-box;
  color: black;
  z-index: 100;
}

.search .results .r {
  border-bottom: 1px solid black;
  padding: 5px 10px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
}

.search .results .r.highlight {
  background: #a0968b;
}

h4,
.search >>> input {
  margin: 0;
  font-size: 14px;
  padding-bottom: 2px;
  font-weight: normal;
}

h4 {
  line-height: 24px;
}

.search >>> input {
  font-family: Roboto, sans-serif;
  line-height: 19px;
  margin-top: -1px;
}
.search >>> input::placeholder {
  font-family: Roboto, sans-serif;
}

.bezirk.cutoff {
  display: flex;
  flex-direction: column;
}

.bezirk.cutoff .placeholder {
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  flex-grow: 2;
  vertical-align: middle;
  text-align: center;
}

button {
  border: none;
  font-size: 16px;
  padding: 0.28em 20px 0.25em;
  margin-left: 1em;
  cursor: pointer;
  background: #ca5775;
  color: white;
  border-radius: 50px;
  vertical-align: top;
}
button:hover {
  background: #bb8b98;
}
button.active {
  cursor: inherit;
  font-weight: bold;
  background: #bb8b98;
}
button.active:hover {
  background: #bb8b98;
}

.bezirk.cutoff .placeholder label {
  background: #ca5775;
  max-width: 75%;
  padding: 0.28em 20px 0.2em;
  color: white;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  border-radius: 50px;
}
.bezirk.cutoff .placeholder label:hover {
  background: #bb8b98;
}

button:first-child {
  margin-left: 0;
}

.controls {
  margin-top: 0.75em;
  text-align: center;
}

span.mark {
  font-size: 8px;
  line-height: 8px;
  font-weight: bold;
  display: inline-block;
  background: #8e8e8e;
  color: white;
  padding: 2px 3px;
  border-radius: 100px;
  vertical-align: middle;
  text-align: center;
  width: 11px;
  height: 11px;
  box-sizing: border-box;
}
</style>
